import { render, staticRenderFns } from "./CollapsibleOption.vue?vue&type=template&id=da48d182&"
import script from "./CollapsibleOption.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./CollapsibleOption.vue?vue&type=script&lang=ts&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports